import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import PlayButtonDefaultIcon from './assets/play-button-default-image';
import PlayButtonDefaultWhiteIcon from './assets/play-button-default-white';

import './youtube-player.less';

const defaultDimensions = {
  height: '232px',
  width: '100%',
};

const renderDefaultPlayButton = (defaultPlayButtonIcon) => {
  const type = {
    default: <PlayButtonDefaultIcon />,
    white: <PlayButtonDefaultWhiteIcon />,
  };
  return type[defaultPlayButtonIcon];
};

const YouTubePlayer = ({
  videoSlug,
  width = defaultDimensions.width,
  height = defaultDimensions.height,
  imagePlaceholder = '',
  playButtonImage = '',
  defaultPlayButtonIcon = 'default',
  imagePlaceholderCoverSize = 'cover',
  enableModestbranding = false,
}) => {
  const modestbranding = enableModestbranding ? '1' : '0';
  const src = `https://www.youtube.com/embed/${videoSlug}?autoplay=1&rel=0&modestbranding=${modestbranding}`;
  const [showPlayer, setShowPlayer] = useState(false);

  const handleLoadPlayer = () => {
    setShowPlayer(true);
  };

  return (
    <Box
      id="you-tube-player-container"
      onClick={handleLoadPlayer}
      style={{
        maxHeight: height || defaultDimensions.height,
        width,
      }}
      className="video-placeholder"
    >
      {showPlayer ? (
        <iframe
          title="video embed"
          id="youtube-iframe"
          type="text/html"
          width="100%"
          height="100%"
          src={src}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <React.Fragment>
          {playButtonImage ? (
            <img
              className="custom-btn-image"
              id="default-player-btn"
              src={playButtonImage}
              alt="Play Button"
            />
          ) : (
            renderDefaultPlayButton(defaultPlayButtonIcon)
          )}
          <Image
            objectFit={imagePlaceholderCoverSize}
            src={imagePlaceholder}
            alt="player-cover-image"
            backgroundColor="transparent"
            naturalWidth={564}
            naturalHeight={316}
            lazy
          />
        </React.Fragment>
      )}
    </Box>
  );
};

YouTubePlayer.propTypes = {
  videoSlug: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  playButtonImage: PropTypes.string,
  imagePlaceholder: PropTypes.string,
  defaultPlayButtonIcon: PropTypes.oneOf(['default', 'white']),
  imagePlaceholderCoverSize: PropTypes.oneOf(['auto', 'contain', 'cover']),
  enableModestbranding: PropTypes.bool,
};

export default YouTubePlayer;
